import React from 'react';
export function FooterSection() {
  return <footer className="w-full py-6 px-4 bg-[#050a10] border-t border-white/5" data-id="element-95">
      {/* Empty minimal footer */}
    </footer>;
}